var map = {
	"./3Dian5_2.png": "8c1f",
	"./3Dian5_3.png": "95f9",
	"./3Dian5_4.png": "6597",
	"./3Dian5_5.png": "9533",
	"./3Dian5_6.png": "15d9",
	"./3Dian5_7.png": "592b",
	"./3Dian5_8.png": "521f",
	"./3Dian5_9.png": "2ab7",
	"./Lightbrown.png": "51a3",
	"./Pink.png": "4d91",
	"./Purple.png": "fd9d",
	"./black.png": "bcf0",
	"./blue.png": "361b",
	"./green.png": "8c95",
	"./green3Dian5.png": "bf88",
	"./jiuhong.png": "1057",
	"./liangcheng.png": "2c02",
	"./red.png": "7ab4",
	"./shenganlanlv.png": "4add",
	"./shentianlan.png": "2580",
	"./shenzihong.png": "cdfe",
	"./yellow.png": "f08f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e21c";